const Strings = {
  tutorial: {
    slide1: [
      { fontSize: 25, text: 'Are you ready to start?' },
      { fontSize: 25, text: 'Press the (→) key.' },
    ],
    slide2: [
      {
        fontSize: 25,
        text:
          "Please place both your index fingers on the keyboard's arrow keys (← →). Keep in mind that during the task, the (→) key means YES, and the (←) key means NO.",
      },
      { fontSize: 25, text: 'To move forward, press the (→) key.' },
    ],
    finish: [
      { fontSize: 25, text: 'Feel free to take some rest.' },
      { fontSize: 25, text: 'Press the (→) key to start main trial.' },
    ],
    feedback: [
      {
        fontSize: 25,
        text:
          'Please pay attention to the feedback you receive after responding to each asterisk stimulus. A red asterisk indicates that your response was incorrect, while a green asterisk signifies that you provided the correct answer.',
      },
      { fontSize: 25, text: 'Press the (→) key to continue' },
    ],
    feedback2: [
      {
        fontSize: 25,
        text:
          'After providing your answer the question mark in each cell, you will receive feedback. A red question mark in the cell indicates that your response was incorrect, while a green question mark signifies that you answered correctly.',
      },
      { fontSize: 25, text: 'Press the (→) key to continue' },
    ],
    mainSlides: {
      slide1: [
        {
          fontSize: 25,
          text:
            "In the following, you will be presented with a grid on which a random letter—either 'I' or 'H'—will appear at the beginning of each trial. Your task is to visualize this letter on a blank grid that will be shown subsequently. Please keep your focus fixed on the center of the grid throughout the entire trial.",
        },
        { fontSize: 25, text: 'Press the (→) key.' },
      ],
      slide2: [
        {
          fontSize: 25,
          text:
            'While you are visualizing the required letter on the grid, pay attention as several dots will appear briefly in some cells of the grid. Try to memorize the cells where the dots were presented while keeping your eyes on the center of the grid—resist the urge to look away from the center.',
        },
        { fontSize: 25, text: 'Press the (→) key.' },
      ],
      slide3: [
        {
          fontSize: 25,
          text:
            'Please be aware that during the presentation of dots on the grid, an asterisk (*) will also be shown in a random cell. If this asterisk falls within the area of the grid where you are visualizing the letter, press the (→) key. If it falls outside of the visualized letter, press the (←) key.',
        },
        { fontSize: 25, text: 'Press the (→) key.' },
      ],
      slide4: [
        {
          fontSize: 25,
          text:
            'Following this, question marks will appear in some cells of the grid. If you recall seeing a dot in the cell where the question mark now appears, press the (→) key. If you think a dot was not presented in that cell, press the (←) key. In this phase, you are not required to keep visualizing the letter and focusing on the center of the grid. At the end of each trial, if you feel you need to take a break, please do so.',
        },
        { fontSize: 25, text: 'press the (→) key to start the next trial.' },
      ],
      slide5: [
        {
          fontSize: 25,
          text:
            'While you are visualizing the required letter on the grid, some asterisks (*) will also be shown in multiple cells. If the asterisk falls within the area of the grid where you are visualizing the letter, press the (→) key. If it falls outside of the visualized letter, press the (←) key. Try to be as fast as you can.',
        },
        { fontSize: 25, text: 'Press the (→) key.' },
      ],
    },
  },
  restSlide: [
    { fontSize: 25, text: 'Feel free if you need to take some rest.' },
    { fontSize: 25, text: 'To move forward, press the (→) key.' },
  ],
  trial: {
    exit: [
      { fontSize: 25, text: 'Press the (→) key to start the next trial.' },
    ],
  },
}
export default Strings
